import Button from '@/shared/Buttons/Button'
import css from './addToFavouriteButton.module.css'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import userApi from '@/pages/User/user.api'
import { useRecoilState } from 'recoil'
import favouriteEquipmentsAtom from '@/pages/User/atoms/favouriteEquipment.atom'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import { useMemo } from 'react'
import StarIcon from '@/assets/icons/starLine.svg?react'
import StarFillIcon from '@/assets/icons/starFill.svg?react'

interface IProps {
  equipmentId: IEquipment['id']
}

const AddToFavouriteButton = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [favouriteEquipments, setFavouriteEquipments] = useRecoilState(favouriteEquipmentsAtom)

  const isFavourite = useMemo(() => {
    return favouriteEquipments.items.findIndex((item) => item === props.equipmentId) > -1
  }, [favouriteEquipments])

  const handleSubscribeToggle = () => {
    if (loading) return

    const method = isFavourite ? userApi.removeEquipmentFromFavourite : userApi.addEquipmentToFavourite

    const toggleFavourite = isFavourite
      ? favouriteEquipments.items.filter((id) => id !== props.equipmentId)
      : [...favouriteEquipments.items, props.equipmentId]

    wait(method(props.equipmentId), (resp) => {
      if (resp.status === 'success') {
        setFavouriteEquipments((prev) => ({
          ...prev,
          items: toggleFavourite,
        }))
      }
    })
  }

  return (
    <div className={css.container}>
      <Button
        fullWidth={true}
        size="default"
        type={isFavourite ? 'primary' : 'default'}
        onClick={handleSubscribeToggle}
        loading={loading}
        icon={isFavourite ? <StarFillIcon width="16px" height="16px" /> : <StarIcon width="16px" height="16px" />}
      />
    </div>
  )
}

export default AddToFavouriteButton
